// src/pages/BookingPage.jsx

import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { initiateBookingPayment } from "../services/booking";

const BookingPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const { amount, title } = location.state || {};

  const planMap = {
    Starter: "starter",
    Extended: "extended",
    Pro: "pro",
  };

  const handleCheckout = async () => {
    if (!email) return alert("Please enter your email");

    const plan_id = planMap[title];

    if (!plan_id) {
      alert("Invalid plan selected");
      return;
    }

    setLoading(true);

    try {
      const data = await initiateBookingPayment({
        email,
        plan_id,
      });

      console.log("BOOKING RESPONSE:", data);

      const paymentLink =
        data?.data?.link ||
        data?.link ||
        data?.data?.data?.link;

      if (paymentLink) {
        // ✅ SAFE REDIRECT ONLY
        window.location.href = paymentLink;
      } else {
        alert("Payment link not generated");
      }
    } catch (err) {
      console.error("Checkout error:", err);
      alert("Payment error");
    } finally {
      setLoading(false);
    }
  };

  if (!amount) {
    return (
      <div style={{ padding: 30 }}>
        <h2>Invalid booking session</h2>
        <button onClick={() => navigate("/")}>Go Home</button>
      </div>
    );
  }

  return (
    <div style={{ padding: 30, maxWidth: 500, margin: "auto" }}>
      <h1>🎬 Booking Checkout</h1>

      <div style={{ marginTop: 20 }}>
        <p>
          <b>Session:</b> {title}
        </p>
        <p>
          <b>Amount:</b> ₦{amount}
        </p>
      </div>

      <input
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{
          padding: 12,
          width: "100%",
          marginTop: 20,
          border: "1px solid #ddd",
          borderRadius: 6,
        }}
      />

      <button
        onClick={handleCheckout}
        disabled={loading}
        style={{
          marginTop: 20,
          padding: "12px 20px",
          width: "100%",
          background: loading ? "#999" : "#2575fc",
          color: "#fff",
          border: "none",
          borderRadius: 8,
        }}
      >
        {loading ? "Processing..." : "Proceed to Checkout"}
      </button>
    </div>
  );
};

export default BookingPage;